export const ZOOM_LEVEL_MARGIN = 8;

export const PopularMapMarkerColors = [
  '#00b7eb',
  '#FF6347', // Tomato
  '#1E90FF', // Dodger Blue
  '#32CD32', // Lime Green
  '#8A2BE2', // Blue Violet
  '#FFA500', // Orange
  '#FFD700', // Gold
  '#00CED1', // Dark Turquoise
  '#FF1493', // Deep Pink
  '#6A5ACD', // Slate Blue
  '#DC143C', // Crimson
];
